import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHomeSelectedNavIconSecondary from './svgs/HomeSelectedNavIconSecondary.js';
import SvgHomeSelectedNavIcon from './svgs/HomeSelectedNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var homeSelectedNavIcon = (props => useIcon(SvgHomeSelectedNavIcon, SvgHomeSelectedNavIconSecondary, props));

export { homeSelectedNavIcon as default };
